import { ACTION_TYPE, fetchJson } from '../../store/actionCreatorsHelpers';

export function giveFeedback(appName: string, content: string) {
    return {
        type: ACTION_TYPE.SUBMIT_FEEDBACK,
        payload: fetchJson('api/feedback/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                appName,
                content,
            }),
        }),
    };
}
